import { render } from "./Sponsoring.vue?vue&type=template&id=4beb4b31&scoped=true"
import script from "./Sponsoring.vue?vue&type=script&lang=js"
export * from "./Sponsoring.vue?vue&type=script&lang=js"

import "./Sponsoring.vue?vue&type=style&index=0&id=4beb4b31&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beb4b31"]])

export default __exports__